<template>
  <div>
    <common-dialog ref="dialog" width="1300px" title="加工单列表" id-key="UserId" @close-saved="$emit('close-saved')">
      <!-- <list ref="list"  :temp-params="{status : 3, ProductionType: 0, OrderType}"></list> -->
      <productList ref="productList" v-if="InType == 1" :temp-params="{ status: 3, OrderType, ProductionType, InType, DpId, TradeUnitId }"></productList>
      <orderList ref="orderList" v-if="InType == 2" :temp-params="{ status: 3, OrderType, ProductionType, InType, DpId, TradeUnitId }"></orderList>
      <div slot="footer">
        <el-button type="primary" @click="saved">保存</el-button>
      </div>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
// import list from "./list";
import orderList from './orderList'
import productList from './productList'
import list from '@/views/business/stock/workList/index'

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  props: {
    OrderType: {
      type: Number,
      default: 0
    },
    InType: {
      type: Number,
      default: 1
    },
    DpId: {
      type: Number,
      default: 0
    },
    TradeUnitId: {
      default: null
    },
    ProductionType: {
      type: Number,
      default: 0
    }
  },
  components: {
    commonDialog,
    list,
    orderList,
    productList
  },
  methods: {
    get_data(o) {
      this.$nextTick(() => {
        console.log('o', o)
        // this.$refs.list.$refs.list.query(o)
        if (this.InType == 1) {
          this.$refs.productList.$refs.list.query(o)
        } else {
          this.$refs.orderList.$refs.list.query(o)
        }
      })
    },
    saved() {
      let list, subList 
      if (this.InType == 1) {
        list = this.$refs.productList.list
        subList = this.$refs.productList.subList
      } else {
        list = this.$refs.orderList.list
        subList = this.$refs.orderList.subList
      }

      this.$emit('saved', {
          list,
          subList
        })
      this.close()
    }
  }
}
</script>
